import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Store Edit Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-store-edit-outline',
    templateUrl: './icon-store-edit-outline.component.html',
    styleUrls: ['./icon-store-edit-outline.component.scss'],
    standalone: false
})
export class IconStoreEditOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
